<template>
    <div class="card">
        <datatable tableId="certificateList" :columns="columns" :data="certificates"
            @deleteRows="showDeleteCertificates" :deletable="deletable" :compact="true" :selectCheckboxes="true"
            :ignoreCache="true"
            :detailColumn="{ baseUrl: 'certificates/', name: 'aUT Certificate', identifier: 'commonName' }" />
    </div>
</template>

<script>
import Datatable from "../../components/Datatable.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "Certificates",
    components: { Datatable },
    data() {
        return {
            columns: [
                { data: "commonName", title: "Name" },
                {
                    data: "sans",
                    render: function (data, type, row) {
                        if (!data) return "0";
                        return data.length;
                    },
                },
            ],
            certificates: null,
        };
    },
    methods: {
        showDeleteCertificates(rows) {
            this.showModal({ component: "deleteCertificate", data: rows });
        },
        ...mapActions({
            showModal: "showModal",
            fetchCertificates: "aut/fetchCertificates",
        }),
        async fetchCertificatesList() {
            await this.fetchCertificates().then((response) => {
                this.certificates = response.data
            }).catch(err => {
                console.log("error: ", err)
                let error = null
                if (err.response)
                    error = err.response.data.error;
                else error = err.message;
                let toastOptions = {
                    message: error || "Something went wrong while fetching certificates. Please contact support.",
                    type: "error"
                }
                this.$store.dispatch("addToast", toastOptions);
            })
        }
    },
    async beforeMount() {
        await this.fetchCertificatesList();
    },
    watch: {
        '$store.state.aut.listCertTrigger': {
            handler(newValue) {
                this.fetchCertificatesList();
            },
            deep: true
        },
    },
    computed: {
        deletable() {
            const allowedRoles = [1, 1.5, 3];
            return allowedRoles.includes(this.$store.getters.userRoles.userRoleRank);
        }
    }

};
</script>

<style scoped></style>